import {applyMiddleware, combineReducers, compose, createStore} from "redux";
import reducers from "./reducers";
import middlewares from "./middlewares/index";
import {setLocale, syncTranslationWithStore} from 'react-redux-i18n';
import {createEpicMiddleware} from 'redux-observable';
import Cookie from "js-cookie";
import {ajax} from 'rxjs/ajax';
import buildUrl from 'build-url';

const ajaxWithXSRF = (method) => (url, body, queryParams) => ajax({
    url: buildUrl(url, {queryParams: method === 'GET' ? body : queryParams}),
    method,
    crossDomain: true,
    headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': Cookie.get('XSRF-TOKEN')
    },
    body: method === 'GET' ? undefined : body
});

const epicMiddleware = createEpicMiddleware({
    dependencies: {
        sendPost: ajaxWithXSRF('POST'),
        sendPut: ajaxWithXSRF('PUT'),
        sendGet: ajaxWithXSRF('GET')
    }
});

// export const store = compose(applyMiddleware(...middlewares, epicMiddleware))(createStore)(combineReducers(reducers));

export const store = compose(applyMiddleware(...middlewares, epicMiddleware))(createStore)(combineReducers(reducers),window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());


syncTranslationWithStore(store);
store.dispatch(setLocale('en'));



// WEBPACK FOOTER //
// ./src/redux/store.js